module.exports = __webpack_public_path__ + "img/gesture-course.aea93f55.png";